var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"item-stars"}},_vm._l((_vm.stars),function(star){return (star.isSelected || !_vm.showOnlySelected)?_c('i',{key:star.id,staticClass:"icon-cr",class:{
            'icon-star-half-yellow': star.isSelected && star.halfSelected,
            'icon-star-yellow': star.isSelected && !star.halfSelected,
            'icon-star': !star.isSelected,
        },attrs:{"id":star.id}}):_vm._e()}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }